export const IPO_VIEWS = Object.freeze(['upcoming', 'recent']);
export const IPO_SORT_FIELDS = Object.freeze(['date', 'ticker', 'company']);
export const IPO_SORT_DIRECTIONS = Object.freeze(['asc', 'desc']);

export function hasUpcomingIposAccess(userFeatures = {}) {
  const permissions = userFeatures && userFeatures.permissions ? userFeatures.permissions : {};
  return Boolean(
    permissions.next_IPOs_mundial
    || permissions.next_IPOs_euro_zone
    || permissions.next_IPOs_usa_zone
  );
}

export function defaultIpoSortDirection(view) {
  return view === 'recent' ? 'desc' : 'asc';
}

export function normalizeIpoRouteQuery(query = {}) {
  const view = IPO_VIEWS.includes(query.view) ? query.view : 'upcoming';
  const sort = IPO_SORT_FIELDS.includes(query.sort) ? query.sort : 'date';
  const defaultDirection = defaultIpoSortDirection(view);

  return {
    view,
    query: typeof query.q === 'string' ? query.q.slice(0, 100) : '',
    country: typeof query.country === 'string' && query.country.trim() ? query.country.trim() : 'all',
    sort,
    direction: IPO_SORT_DIRECTIONS.includes(query.direction) ? query.direction : defaultDirection
  };
}

export function serializeIpoRouteQuery(state = {}) {
  return {
    view: IPO_VIEWS.includes(state.view) ? state.view : 'upcoming',
    q: String(state.query || '').trim(),
    country: String(state.country || 'all'),
    sort: IPO_SORT_FIELDS.includes(state.sort) ? state.sort : 'date',
    direction: IPO_SORT_DIRECTIONS.includes(state.direction)
      ? state.direction
      : defaultIpoSortDirection(state.view)
  };
}

export function sortUpcomingIpos(items = [], view = 'upcoming', field = 'date', direction) {
  const normalizedView = IPO_VIEWS.includes(view) ? view : 'upcoming';
  const normalizedField = IPO_SORT_FIELDS.includes(field) ? field : 'date';
  const normalizedDirection = IPO_SORT_DIRECTIONS.includes(direction)
    ? direction
    : defaultIpoSortDirection(normalizedView);
  const factor = normalizedDirection === 'desc' ? -1 : 1;

  return items
    .filter(item => item.phase === normalizedView)
    .slice()
    .sort((left, right) => {
      const leftValue = normalizedField === 'date'
        ? left.listingDate
        : normalizedField === 'company' ? left.companyName : left.ticker;
      const rightValue = normalizedField === 'date'
        ? right.listingDate
        : normalizedField === 'company' ? right.companyName : right.ticker;
      return String(leftValue || '').localeCompare(String(rightValue || ''), 'es', { sensitivity: 'base' }) * factor;
    });
}

export function formatIpoDate(dateValue) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(dateValue || ''))) return '';
  const date = new Date(`${dateValue}T00:00:00`);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }).format(date);
}
